// very helpful: https://www.bezkoder.com/react-hooks-jwt-auth

import * as React from 'react';
import { Fragment } from 'react'; // So it doesn't create a unnecessary node element. **Only available in react 16+
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';

import * as yup from "yup";
import { useFormik } from "formik";

import { login } from "src/services/auth"

import { useNavigate, Link as routerLink } from "react-router-dom";

import {
    select_userMessage, setUserMessage
} from 'src/reducers/basicReducer';
import { useDispatch, useSelector } from 'react-redux'

// https://stackoverflow.com/questions/55631485/typescript-yup-expected-0-arguments-but-got-1-ts2554
// https://formik.org/docs/examples/with-material-ui (validationSchema mui example)
const validationSchema = yup.object({
    email: yup
        .string()
        .email('Enter a valid email')
        .required('Email is required'),
    password: yup
        .string()
        .min(8, 'Password should be of minimum 8 characters length')
        .required('Password is required'),
});

function Copyright(props: any) {
    return (
        <Typography variant="body2" color="text.secondary" align="center" {...props}>
            {'Copyright © '}
            <Link color="inherit" href="https://robotenlightenment.com/">
                Robot Enlightenment
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}

const theme = createTheme();

export default function SignIn() {

    // https://redux.js.org/tutorials/essentials/part-2-app-structure
    // const [loading, setLoading] = React.useState(false);
    // const [message, setMessage] = React.useState("");
    const message = useSelector(select_userMessage); // hook! (stateful)
    const dispatch = useDispatch()

    let navigate = useNavigate();

    const formik = useFormik({

        initialValues: {
            email: '',
            password: '',
            remember: false
        },
        validationSchema: validationSchema,
        onSubmit: values => {
            // alert(JSON.stringify(values, null, 2));
            console.log(values);

            login(values.email, values.password, values.remember).then(
                () => {
                    // https://stackoverflow.com/questions/3262605/how-to-check-whether-a-storage-item-is-set
                    if (values.remember) {
                        localStorage.setItem("remember", "");
                    } else {
                        localStorage.removeItem("remember"); // in case it was set earlier
                    }

                    console.log("remember: ");
                    console.log(localStorage.hasOwnProperty("remember"));

                    navigate("/dashboard");
                    // window.location.reload(); // this seems unhelpful; optional TODO - consider if it has a purpose here
                },
                (error) => {
                    console.log("Signin failed!!!");
                    console.log(error);
                    // resMessage is for if we want to automatically determine the issue to display
                    // const resMessage =
                    //     (error.response &&
                    //         error.response.data &&
                    //         error.response.data.message) ||
                    //     error.message ||
                    //     error.toString();
                    // setLoading(false);

                    if (error.response.data.detail != null && error.response.data.detail === "No active account found with the given credentials") {
                        dispatch(setUserMessage("Invalid credentials"));
                    } else {
                        dispatch(setUserMessage("Unknown error"));
                    }
                }
            );
        }
    });

    return (
        <ThemeProvider theme={theme}>
            <Container component="main" maxWidth="xs">
                <CssBaseline />
                <Box
                    sx={{
                        marginTop: 8,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}
                >
                    <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
                        <LockOutlinedIcon />
                    </Avatar>
                    <Typography component="h1" variant="h5">
                        Sign in
                    </Typography>
                    <Box
                        component="form"
                        onSubmit={formik.handleSubmit}
                        noValidate
                        sx={{ mt: 1 }}
                    >
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            id="email"
                            name="email"
                            label="Email Address"
                            value={formik.values.email}
                            onChange={formik.handleChange}
                            error={formik.touched.email && Boolean(formik.errors.email)}
                            helperText={formik.touched.email && formik.errors.email}
                        />
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            id="password"
                            name="password"
                            label="Password"
                            type="password"
                            value={formik.values.password}
                            onChange={formik.handleChange}
                            error={formik.touched.password && Boolean(formik.errors.password)}
                            helperText={formik.touched.password && formik.errors.password}
                        />

                        {/* TODO: move style to css! */}
                        {message && (
                            <div className="form-group">
                                <div className="alert alert-danger" role="alert" style={{ color: 'red' }}>
                                    {message}
                                </div>
                            </div>
                        )}

                        {/* https://stackoverflow.com/questions/63721055/react-hooks-remember-me-checkbox-in-login-form-not-working */}
                        <FormControlLabel
                            control={<Checkbox id="remember" name="remember" value={formik.values.remember} onChange={formik.handleChange} color="primary" />}
                            label="Remember me"
                        />
                        <Button
                            type="submit"
                            onClick={() => {
                                // erase user message if new submission is attempted
                                // https://stackoverflow.com/questions/61962001/how-to-make-the-formik-call-a-function-when-the-form-is-invalid
                                dispatch(setUserMessage(""))
                            }}
                            fullWidth
                            variant="contained"
                            sx={{ mt: 3, mb: 2 }}
                        >
                            Sign In
                        </Button>
                        <Grid container>
                            <Grid item xs>
                                {/* Used router's "Link" to cleanly stay on same page https://stackoverflow.com/questions/35978489/how-to-link-to-same-page
                                combined with mui's version for formatting https://stackoverflow.com/questions/63216730/can-you-use-material-ui-link-with-react-router-dom-link .
                                Could just do mui link with href="#", but URL looks funny that way.
                                TODO - consider if we should do a separate page for recovery or make the email address a link with mailto (autofill subject??)?.
                                Should we even be using a "link" (maybe just an open button)
                                TODO - ultimately recovery should be automated (so, probably won't spend much time working on current approach) */}
                                <Link
                                    component={routerLink}
                                    to={{}}
                                    variant="body2"
                                    //onClick={() => dispatch(setUserMessage("Please contact support@robotenlightenment.com"))}
                                    onClick={() => dispatch(setUserMessage(<Fragment>Please contact <Link href="https://robotenlightenment.com/contact">
                                        {"support"}
                                    </Link></Fragment>))}
                                >
                                    Forgot password?
                                </Link>
                            </Grid>
                            {/* <Grid item>
                                <Link href="signup" variant="body2">
                                    {"Don't have an account? Sign Up"}
                                </Link>
                            </Grid> */}
                        </Grid>
                    </Box>
                </Box>
                <Copyright sx={{ mt: 8, mb: 4 }} />
            </Container>
        </ThemeProvider >
    );
}
